import {parse, compareAsc, compareDesc} from 'date-fns';
import {DateFormatEnum} from 'presentation/constants';

interface SortBookedConstraint {
	date?: string;
}

interface SortBookedByDateProps<T> {
	list: T[];
	order?: 'asc' | 'desc';
	type?: 'history' | 'booked';
}

export function sortBookedByDate<T extends SortBookedConstraint>({
	list,
	order = 'asc',
	type = 'booked',
}: SortBookedByDateProps<T>) {
	return list.toSorted((a, b) => {
		const dateA = a.date;
		const dateB = b.date;
		const dateFormat =
			type === 'booked' ? DateFormatEnum.DATE_FORMAT_1 : DateFormatEnum.DATE_FORMAT_2;

		if (!dateA || !dateB) {
			return 0;
		}

		const parsedDateA = parse(dateA, dateFormat, new Date());
		const parsedDateB = parse(dateB, dateFormat, new Date());

		if (Number.isNaN(parsedDateA.getTime()) || Number.isNaN(parsedDateB.getTime())) {
			return 0;
		}

		return order === 'desc'
			? compareAsc(parsedDateA, parsedDateB)
			: compareDesc(parsedDateA, parsedDateB);
	});
}
